import SettingsIcon from "@material-ui/icons/Settings";
import CouponsSetting from "./CouponsSetting";

// const permission = localStorage.getItem("permission");
const SettingCoupons = {
  list: CouponsSetting,
  icon: SettingsIcon,
};
export default SettingCoupons;
